
export const environment = {
  sentryEnvironment: 'local',
  sentryDsn: 'https://e372bad683dff9b077557c0a1c01b271@o1338134.ingest.us.sentry.io/4510651437088768',
  sentryTracesSampleRate: 0.1,
  sentryReplaysSessionSampleRate: 0.5,
  sentryDebug: false,
};
